import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSidebar } from '../SidebarContext';
import Sidebar from './SideBar';
import PropertyCategoryUpdateModal from './PropertyCategoryUpdateModal';

const PropertyCategoryUpdate = () => {
    const { isSidebarOpen } = useSidebar();

    const [searchQuery, setSearchQuery] = useState('');
    const [amenities, setAmenities] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [inputValue, setInputValue] = useState('');
    const [inputValuelink, setInputValuelink] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);

    const [editIndex, setEditIndex] = useState(null);
    const [editValue, setEditValue] = useState('');

    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const BASE_URL = `${process.env.REACT_APP_LINK}`;

    useEffect(() => {
        fetchAmenities();
    }, []);

    const fetchAmenities = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/propertycategory/all/${isLoggedIn.user_id}`);
            setAmenities(response.data.reverse());
        } catch (error) {
            console.error('Error fetching amenities:', error);
        }
    };

    const handleInputChange = (e) => setInputValue(e.target.value);
    const handleInputChangeLink = (e) => setInputValuelink(e.target.value);
    const handleFileChange = (e) => setSelectedFile(e.target.files[0]);
    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const handleAddAmenities = async () => {
        if (!inputValue.trim()) {
            toast.warning('Please enter category name');
            return;
        }

        const newAmenities = inputValue.split(',').map((a) => a.trim()).filter((a) => a !== '');
        const dataToUpdate = {
            name: newAmenities[0],
            status: 'active',
            user_id: isLoggedIn.user_id
        };

        try {
            const response = await axios.post(`${BASE_URL}/propertycategory/igothousifyu`, dataToUpdate);
            if (response.status === 200) {
                toast.success('New Category Added');
                fetchAmenities();
                setInputValue('');
                setInputValuelink('');
                setSelectedFile(null);
                setIsModalOpen(false);
            }
        } catch (error) {
            toast.error('Failed to add category');
            console.error('Error adding amenity:', error);
        }
    };

    const handleEditChange = (e) => setEditValue(e.target.value);

    const handleEdit = (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        setEditIndex(absoluteIndex);
        setEditValue(amenities[absoluteIndex].name);
    };

    const handleSaveEdit = async () => {
        const amenity = amenities[editIndex];
        const dataToUpdate = { name: editValue, status: amenity.status };

        try {
            const response = await axios.put(`${BASE_URL}/propertycategory/change/${amenity.id}`, dataToUpdate);
            if (response.status === 200) {
                toast.success('Category Updated');
                fetchAmenities();
                setEditIndex(null);
                setEditValue('');
            }
        } catch (error) {
            toast.error('Failed to update category');
            console.error('Error updating amenity:', error);
        }
    };

    const handleDelete = async (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        const amenity = amenities[absoluteIndex];
        try {
            const response = await axios.delete(`${BASE_URL}/propertycategory/${amenity.id}`);
            if (response.status === 200) {
                toast.success('Category Deleted');
                fetchAmenities();
            }
        } catch (error) {
            toast.error('Failed to delete category');
            console.error('Error deleting amenity:', error);
        }
    };

    const handleToggleStatus = async (index) => {
        const absoluteIndex = indexOfFirstItem + index;
        const amenity = amenities[absoluteIndex];
        const updatedStatus = amenity.status === 'active' ? 'inactive' : 'active';

        try {
            const response = await axios.put(`${BASE_URL}/propertycategory/change/${amenity.id}`, {
                status: updatedStatus,
            });
            if (response.status === 200) {
                toast.success('Status Updated');
                fetchAmenities();
            }
        } catch (error) {
            toast.error('Failed to update status');
            console.error('Error toggling status:', error);
        }
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const filteredAmenities = amenities.filter((item) =>
        ['name', 'status'].some((key) =>
            String(item[key]).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const totalPages = Math.ceil(filteredAmenities.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredAmenities.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Property Categories</h1>
                    <button className="oms-add-btn" onClick={openModal}>
                        Add Category
                    </button>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length > 0 ? (
                                currentItems.map((amenity, index) => {
                                    const absoluteIndex = indexOfFirstItem + index;
                                    return (
                                        <tr key={amenity.id}>
                                            <td>
                                                {editIndex === absoluteIndex ? (
                                                    <input
                                                        type="text"
                                                        value={editValue}
                                                        onChange={handleEditChange}
                                                        onBlur={handleSaveEdit}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') handleSaveEdit();
                                                        }}
                                                    />
                                                ) : (
                                                    amenity.name
                                                )}
                                            </td>
                                            <td>{amenity.status.charAt(0).toUpperCase() + amenity.status.slice(1)}</td>
                                            <td>
                                                <button onClick={() => handleToggleStatus(index)}>
                                                    <i
                                                        className={`fa ${
                                                            amenity.status === 'active'
                                                                ? 'fa-toggle-on'
                                                                : 'fa-toggle-off'
                                                        }`}
                                                    />
                                                </button>
                                                <button className="edit-button" onClick={() => handleEdit(index)}>
                                                    <i className="fa-solid fa-pencil edit-oms"></i>
                                                </button>
                                                <button className="delete-button" onClick={() => handleDelete(index)}>
                                                    <i className="fa-solid fa-trash delete-oms"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: 'center' }}>No data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>

            <PropertyCategoryUpdateModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                inputValue={inputValue}
                handleInputChange={handleInputChange}
                inputValuelink={inputValuelink}
                handleInputChangeLink={handleInputChangeLink}
                handleFileChange={handleFileChange}
                handleAddAmenities={handleAddAmenities}
            />
        </>
    );
};

export default PropertyCategoryUpdate;
